<template>
  <div>
    <OperationDetailsDialog ref="genericDialog" />
    <div v-for="(op, key) in operationComponents" :key="key">
      <component :is="op" :ref="`op_${key}`" />
    </div>
  </div>
</template>

<script>
import Associate from './Associate.vue'
import Dissociate from './Dissociate.vue'
import AssociateTicket from './AssociateTicket.vue'
import VerifyChecklist from './VerifyChecklist.vue'
import RegisterLoss from './RegisterLoss.vue'
import ChangeDepot from './ChangeDepot.vue'
import TroubleshootInvestigate from './TroubleshootInvestigate.vue'
import TroubleshootSolve from './TroubleshootSolve.vue'
import Install2 from './Install2.vue'
import Remove from './Remove.vue'
import Intervention from './Intervention.vue'
import OperationDetailsDialog from './OperationDetailsDialog.vue'

/**
 * Este componente agrupa todos os dialogs de operations, mais
 * um DetailsDialog genérico, e expõe métodos para iniciar uma
 * operation (startNew()) e para editar um registro já existente
 * (startEdit()).
 *
 * Pode ser montado várias vezes (e.g. uma vez no ClientHistoryTab
 * e uma vez no OperationsMenu que fica ao lado).
 */

export default {
  components: { OperationDetailsDialog },
  data() {
    return {
      operationComponents: {
        Associate,
        Dissociate,

        Install2,
        Remove,
        Intervention,

        TroubleshootInvestigate,
        TroubleshootSolve,
        AssociateTicket,

        VerifyChecklist,
        RegisterLoss,
        ChangeDepot
      }
    }
  },
  methods: {
    async startNew({ code, clientId }) {
      let ref = this.$refs[`op_${code}`]

      const res = await ref[0].open({ clientId })

      if (res === 'RELOAD') this.$emit('reload')

      return res
    },

    async startEdit(genericReportRow) {
      let { id, historyType, historySubType, clientId } = genericReportRow
      let code = findDialogForRow({ historyType, historySubType })

      // eslint-disable-next-line no-console
      console.log('Abrindo dialog para editar', code, genericReportRow)

      let dialog = this.$refs.genericDialog

      if (code != null) dialog = this.$refs[`op_${code}`][0]

      let res = await dialog.open({ clientId, historyId: id })

      if (res === 'RELOAD') this.$emit('reload')

      return res
    }
  }
}

function findDialogForRow({ historyType: t, historySubType: st }) {
  if (t == 'installation') {
    if (st == 'install') return 'Install2'
    if (st == 'remove') return 'Remove'
    if (st == 'intervention') return 'Intervention'
  }

  if (t == 'troubleshooting') {
    if (st == 'identify') return 'TroubleshootInvestigate'
    if (st == 'resolve') return 'TroubleshootSolve'
  }

  if (t == 'associateTicket') return 'AssociateTicket'

  if (t == 'logistic') return 'ChangeDepot'
  if (t == 'loss') return 'RegisterLoss'

  // Todos os demais tipos usam o dialog de detalhes simples
  // e read-only
  // type = 'lease'
  // type = 'rename'
  // type = 'creation'
  // type = 'checklist'
  // type = 'firmwareUpdate'
  // type = 'association', subType = 'start/end'
  return null
}
</script>

<style></style>
